<template>
  <section class="n5-portada" v-if="B">
    <div class="n5-portada__tarjeta">
      <video v-if="esVideo" :src="media" muted autoplay playsinline loop preload="metadata" aria-hidden="true"></video>
      <img v-else-if="media" :src="media" alt="" fetchpriority="high" :style="{ filter: B.ImagenFiltro || undefined }" />
      <div class="n5-portada__texto">
        <h1 v-html="B.Titulo?.Texto || NOTARIA.Nombre"></h1>
        <p v-if="B.Subtitulo?.Texto" class="n5-portada__subtitulo" v-html="B.Subtitulo.Texto"></p>
        <div v-if="B.Texto?.Texto" class="n5-portada__parrafo" v-html="B.Texto.Texto"></div>
        <div class="n5-portada__botones">
          <button v-if="B.ShowButtonMoveMenu && B.ButtonMoveMenu?.Texto" type="button" class="n2-boton n2-boton--acento n2-boton--grande"
            @click="ir(B.ButtonMoveMenu.Click, false)">{{ B.ButtonMoveMenu.Texto }}</button>
          <button v-if="B.ShowButtonMoveInicio && B.ButtonMoveInicio?.Texto" type="button" class="n2-boton n5-boton-cristal n2-boton--grande"
            @click="ir(B.ButtonMoveInicio.Click, true)">{{ B.ButtonMoveInicio.Texto }}</button>
        </div>
      </div>
    </div>

    <!-- Accesos rápidos: llamar, cómo llegar y el horario de hoy -->
    <div v-if="C.Telefono || C.Direccion || C.Horario" class="n5-accesos">
      <a v-if="C.Telefono" :href="'tel:' + C.Telefono.replace(/\s/g, '')">
        <v-icon>mdi-phone-outline</v-icon><span><small>{{ tSolicitud('Llamar') }}</small><strong>{{ C.Telefono.trim() }}</strong></span>
      </a>
      <a v-if="C.Direccion" :href="C.EnlaceMaps || undefined" target="_blank" rel="noopener">
        <v-icon>mdi-map-marker-outline</v-icon><span><small>{{ tSolicitud('Cómo llegar') }}</small><strong>{{ [C.Direccion, C.Municipio].filter(Boolean).join(', ') }}</strong></span>
      </a>
      <div v-if="C.Horario || hoy">
        <v-icon>mdi-clock-outline</v-icon>
        <span v-if="hoy !== null"><small>{{ tSolicitud('Horario de hoy') }}</small><strong>{{ hoy || tSolicitud('Cerrado ahora') }}</strong></span>
        <span v-else><small>{{ T.Footer?.TituloHorario?.Texto || tSolicitud('Horario') }}</small><strong>{{ C.Horario.split('\n')[0] }}</strong></span>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { useAccionBanner } from '../../composables/useNotaria2'
import { horarioDeHoy } from '../../composables/useNotaria5'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, getFile } = useUtils()
const ir = useAccionBanner()

// Panel: Inicio → Banner (mismos textos, imagen o vídeo y botones)
const B = computed(() => NOTARIA.value?.Theme?.Home?.Banner)
const T = computed(() => NOTARIA.value?.Theme ?? {})
const C = computed(() => NOTARIA.value?.Contacto ?? {})
const esVideo = computed(() => getFile(B.value?.Imagen)?.type === 'video/mp4')
const media = computed(() => B.value?.Imagen ? imagenIDtoSRC(B.value.Imagen) : '')

// Depende del día del visitante: solo en el navegador (antes, el horario en texto)
const hoy = ref(null)
onMounted(() => { hoy.value = horarioDeHoy(C.value.HorarioEstructurado) })
</script>
